import type { Scaffold } from "@Light/scaffold";
import { defaultScaffold } from "@Light/scaffold/default";
import { HeaderCloseButton } from "./components/CloseIcon";

export const embeddedScaffold = {
  ...defaultScaffold,
  page: {
    ...defaultScaffold.page,
    header: {
      ...defaultScaffold.page.header,
      defaultRightButton: HeaderCloseButton,
    },
  },
} satisfies Scaffold;

export const toEmbeddedEnrollmentScaffold = <T extends Scaffold>(
  scaffold: T,
): T => ({
  ...scaffold,
  page: {
    ...scaffold.page,
    header: {
      ...scaffold.page.header,
      isMinimalHeader: true,
    },
  },
});
